import { results } from "./results"

export const CATEGORIES = [...new Set(results.map((d) => d.category))]

export const RESULT_IDS = results.map((d) => d.resultId).sort((a, b) => a - b)

export const RESULTS_RENDER_DATA = [
  {
    id: 1,
    title: "Let's start with...",
    shouldInclude: ["app", "drinks"],
    dishes: [],
  },
  {
    id: 2,
    title: "Now, for the main event.",
    shouldInclude: [
      "mains",
      "stuffing",
      "potatoes",
      "sweet-potatoes",
      "bread",
      "sides",
      "salads",
      "cranberry",
    ],
    dishes: [],
  },
  {
    id: 3,
    title: "Pour some coffee—it's time for dessert!",
    shouldInclude: ["pie", "dessert"],
    dishes: [],
  },
]

export const VEG_OPTION = "No, we’re vegetarian."
export const VEGAN_OPTION = "No, we’re vegan."
export const NO_FLAG = ""
export const VEG_FLAG = "veg"
export const VEGAN_FLAG = "vegan"
